import React, {useState} from 'react';
import {makeStyles} from '@mui/styles';
import Button from '@mui/material/Button';
import {theme} from '../../Theme';

const useStyles = (props: $TSFixMe) =>
  makeStyles(() => ({
    tertiaryButton: {
      textTransform: 'inherit',
      color: props.color ? props.color : theme.palette.primary.light,
      borderBottom: `1px solid ${
        props.color ? props.color : theme.palette.primary.light
      }`,
      padding: 0,
      borderRadius: 0,
      minWidth: 'fit-content',
      transition: 'all ease-in 100ms',

      '&:hover': {
        color: `${theme.palette.gray.text} !important`,
        borderBottom: `1px solid ${theme.palette.gray.medium}`,
      },
      '&:disabled': {
        opacity: '33% !important',
      },
    },
  }));

export default function TertiaryButton(props: $TSFixMe) {
  const classes = useStyles(props)();
  const [disabled, setDisabled] = useState(false);

  const handleClick = (event: $TSFixMe) => {
    setDisabled(true);
    Promise.resolve(props.onClick(event)).then(() => setDisabled(false));
  };

  const styles = {
    ...props.style,
    fontSize: props.fontSize || 14,
    lineHeight: props.fontSize ? `${props.fontSize}px` : '14px',
    fontWeight: props.bold ? 'bold' : 'inherit',
  };

  return (
    <Button
      onClick={props.onClick && handleClick}
      className={`${classes.tertiaryButton} ${props.className}`}
      style={styles}
      disabled={props.disabled || disabled}
      component={props.component}
      type={props.type || undefined}
      id={props.id || undefined}>
      {props.children}
    </Button>
  );
}
